import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKgAudioPlaceholder = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M11.25 17.25a6 6 0 1 0 12 0 6 6 0 1 0-12 0Zm6 3v-6m0 0L15 16.5m2.25-2.25 2.25 2.25" }),
		/* @__PURE__ */ _jsx("path", { d: "M8.25 20.25h-6a1.5 1.5 0 0 1-1.5-1.5V2.25a1.5 1.5 0 0 1 1.5-1.5h10.629a1.5 1.5 0 0 1 1.06.439l2.872 2.872a1.5 1.5 0 0 1 .439 1.06V8.25" }),
		/* @__PURE__ */ _jsx("path", { d: "M3.75 12.75a2.25 1.5 0 1 0 4.5 0 2.25 1.5 0 1 0-4.5 0Z" }),
		/* @__PURE__ */ _jsx("path", { d: "m8.25 12.75-.295-5.929 1.062-.113A2.685 2.685 0 0 1 11.6 7.99" })
	]
});
export default SvgKgAudioPlaceholder;
